/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Block_Parties_Two_ColInputs */

const cs_builder_block_parties_two_col = /** @type {(inputs: Builder_Block_Parties_Two_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strany (2 sloupce)`)
};

const en_builder_block_parties_two_col = /** @type {(inputs: Builder_Block_Parties_Two_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parties (two columns)`)
};

/**
* | output |
* | --- |
* | "Parties (two columns)" |
*
* @param {Builder_Block_Parties_Two_ColInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_block_parties_two_col = /** @type {((inputs?: Builder_Block_Parties_Two_ColInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Block_Parties_Two_ColInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_block_parties_two_col(inputs)
	return cs_builder_block_parties_two_col(inputs)
});